import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { login, getMyProfile } from '../services/api';

function LoginPage() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw]     = useState(false);
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(''); // 'performer' | 'admin' | ''
  const navigate = useNavigate();
  const location = useLocation();
  const sessionMessage = location.state?.message ?? null;

  const handleLogin = async (loginAs) => {
    if (!email || !password) { setError('Email and password are required'); return; }
    setError(''); setLoading(loginAs);
    try {
      const res = await login({ email, password, login_as: loginAs });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user',  JSON.stringify(res.data.user));
      if (loginAs === 'performer') {
        try {
          const profileRes = await getMyProfile();
          navigate(profileRes.data.stage_name ? '/profile' : '/profile/edit');
        } catch {
          navigate('/profile/edit');
        }
      } else {
        navigate('/admin');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Sign in failed. Please try again.');
    } finally {
      setLoading('');
    }
  };

  const handlePerformerLogin = () => handleLogin('performer');
  const handleAdminLogin     = () => handleLogin('admin');

  const isLoading = !!loading;

  return (
    <div className="a-auth-page">
      <div className="a-auth-card">
        <div className="a-auth-header">
          <img src="/uploads/scala-logo.png" alt="SCALA" className="a-auth-header__logo" />
          <div className="a-auth-header__title">SCALA Performer Registry</div>
          <div className="a-auth-header__subtitle">Celebrating Songwriting</div>
        </div>
        <div className="a-auth-body">
          <h2>Sign In</h2>

          {sessionMessage && (
            <div style={{
              background: '#eff6ff',
              border: '1px solid #bfdbfe',
              color: '#1d4ed8',
              borderRadius: '6px',
              padding: '0.625rem 0.875rem',
              fontSize: '0.875rem',
              marginBottom: '0.75rem',
            }}>
              {sessionMessage}
            </div>
          )}

          {error && <div className="a-error">{error}</div>}

          <div className="a-field">
            <label className="a-label">Email Address</label>
            <input
              className="a-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoFocus
            />
          </div>
          <div className="a-field">
            <label className="a-label">Password</label>
            <div className="a-pw-wrap">
              <input
                className="a-input"
                type={showPw ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <button type="button" className="a-pw-toggle" onClick={() => setShowPw(v => !v)}>
                {showPw ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <p style={{ fontSize: '12px', color: '#6b7280', textAlign: 'center', margin: '0.25rem 0 1rem' }}>
            If you are already a registered SCALA performer, use your existing password
          </p>

          <p style={{ fontSize: '11px', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.08em', textAlign: 'center', marginBottom: '0.625rem' }}>
            Log in as:
          </p>

          <div style={{ display: 'flex', gap: '0.75rem', marginBottom: '0.5rem' }}>
            <button
              type="button"
              className="a-btn a-btn--navy"
              style={{ flex: 1 }}
              onClick={handlePerformerLogin}
              disabled={isLoading}
            >
              {loading === 'performer' ? 'Signing in…' : 'Performer'}
            </button>
            <button
              type="button"
              style={{
                flex: 1,
                border: '1.5px solid #0ea5e9',
                color: '#0ea5e9',
                background: 'transparent',
                borderRadius: '6px',
                padding: '0.625rem 1rem',
                fontSize: '0.9rem',
                fontWeight: 500,
                cursor: isLoading ? 'not-allowed' : 'pointer',
                opacity: isLoading ? 0.6 : 1,
                transition: 'opacity 0.15s',
              }}
              onClick={handleAdminLogin}
              disabled={isLoading}
            >
              {loading === 'admin' ? 'Signing in…' : 'Admin / View / Book'}
            </button>
          </div>

          <p style={{ textAlign: 'center', marginTop: '1.25rem', fontSize: '0.875rem', color: '#6b7280' }}>
            <Link to="/forgot-password">Forgot your password?</Link>
          </p>
          <p style={{ textAlign: 'center', marginTop: '0.75rem', fontSize: '0.875rem', color: '#6b7280' }}>
            New performer? <Link to="/register">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
